import { Injectable } from '@angular/core';
import { Consorcio } from '../model/Consorcio';
import { Sucursal } from '../model/sucursal';
import { DocumentoDetalleSalida } from '../model/documento-detalle-salida';
import { DocumentoSalida } from '../model/documento-salida';
import { Excepcion } from '../model/excepcion';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service';
import { Resultado } from 'app/model/resultado';
@Injectable()
export class DocumentoDetalleSalidaService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  getDetalle(documento: DocumentoSalida): Observable<DocumentoDetalleSalida[]> {

    let json = { "Metodo": "findDetalleDocumentoSalida", "Datos": documento };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getDetalleByDocumento(codigoConsorcio: string, codigoDocumento: string): Observable<DocumentoDetalleSalida[]> {

    // let json = { "Metodo": "findDetalleDocumentoSalidaByDocument", "Datos": query };

    // let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    // let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    // return this._http.post(this._utilities.getURL("post"),
    //   params, { headers: headers }).map(res => res.json());

    const requestUrl = this._utilities.getURLIIS('DocumentoSalida/salidaaDetalle/' + codigoConsorcio + '/' + codigoDocumento);

    return this._http.get(requestUrl).map((response: Response) => {
      return <DocumentoDetalleSalida[]>response.json();
    });

  }



getDocumentoValidarSerie(codigoConsorcio: string, codigoDocumento: string, idArticulo:
  string, serie: string): Observable<Resultado> {



  const requestUrl = this._utilities.getURLIIS('DocumentoSalida/GetDocumentoValidarSerie/'
    + codigoConsorcio + '/' + codigoDocumento + '/' + idArticulo + '/' + serie);

  return this._http.get(requestUrl).map((response: Response) => {
    return <Resultado>response.json();
  });

}



getDetalleExcepciones(query: any): Observable < Excepcion[] > {

  let json = { "Metodo": "findExcepcionesSalida", "Datos": query };

  let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

  return this._http.post(this._utilities.getURL("get"),
    params, { headers: headers }).map(res => res.json());

}


  public insert(detalle: DocumentoDetalleSalida) {

  let json = { "Metodo": "postDetalleDocumentoSalida", "Datos": detalle };

  let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

  return this._http.post(this._utilities.getURL("post"),
    params, { headers: headers }).map(res => res.json());
}


  public actualizaRecomendacion(query: any) {

  let json = { "Metodo": "actualizarDetalleRecomendacion", "Datos": query };

  let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

  console.log(params);

  return this._http.post(this._utilities.getURL("post"),
    params, { headers: headers }).map(res => res.json());
}

  public delete (detalle: DocumentoDetalleSalida) {

  let json = { "Metodo": "deleteDetalleDocumentoSalida", "Datos": detalle };

  let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


  return this._http.post(this._utilities.getURL("post"),
    params, { headers: headers }).map(res => res.json());
}

  public deleteAll(cabecera: DocumentoSalida) {

  let json = { "Metodo": "deleteAllDetalleDocumentoSalida", "Datos": cabecera };
  let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
  return this._http.post(this._utilities.getURL("post"),
    params, { headers: headers }).map(res => res.json());

}




}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/documento-detalle-salida.service.ts